import { createAction, props } from '@ngrx/store';

export const SetEnvironment = createAction(
  '[Shared: Environment]: Set Environment',
  props<{ isProd: boolean }>(),
);

export const SetAccount = createAction(
  '[Shared: Environment]: Set Account',
  props<{ account: string }>(),
);
